export default "__VITE_ASSET__DhPAp2UA__"